import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.uploadProgress;

const UploadProgressData = createSelector([selector], (state) => state);

export default {
  UploadProgressData
};